import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getResumes, createResume, deleteResume } from '../api/employeesResume.api';
import { IResume, IGetResumes } from '../models/employeesResume.model';

interface IResumeState {
  resumes: IResume[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IResumeState = {
  resumes: [],
  isLoading: false
};

const resumeSlicer = createSlice({
  name: 'resume',
  initialState,
  reducers: {
    getResumesStart: (state: IResumeState) => {
      state.resumes = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getResumesSuccess: (state: IResumeState, action: PayloadAction<IGetResumes>) => {
      state.resumes = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getResumesFailure: (state: IResumeState, action: PayloadAction<AxiosError|string>) => {
      state.resumes = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IResumeState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IResumeState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IResumeState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    deleteSuccess: (state: IResumeState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  }
});

export const {
  getResumesStart,
  getResumesSuccess,
  getResumesFailure,
  requestStart,
  requestFailure,
  createSuccess,
  deleteSuccess
} = resumeSlicer.actions;

export default resumeSlicer.reducer;

export const doGetResumes = (memberId: string): any => async (dispatch: any) => {
  try {
    dispatch(getResumesStart());
    const response = await getResumes(memberId);
    dispatch(getResumesSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getResumesFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateResume = (memberId: string, data: any): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createResume(memberId, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doDeleteResume = (resumeId: string): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await deleteResume(resumeId);
    dispatch(deleteSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
